import jsPDF from "jspdf";
import { autoTable, CellHookData } from "jspdf-autotable";

export const generateInvoicePDF = ({
  name = "John Doe",
  email = "john.doe@example.com",
  phone = "+1234567890",
  invoiceNumber = "INV-001",
  invoiceDate = "2023-10-01",
  status = "Paid",
  paymentMethod = "Credit Card",
  imageSrc = "/anyimage.png"
} = {}) => {
  const doc = new jsPDF();
  const img = new window.Image();
  img.src = imageSrc;
  img.crossOrigin = "anonymous";
  img.onload = function () {
    // Draw image to canvas to get base64
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(img, 0, 0);
    }
    const imgData = canvas.toDataURL('image/png');

    // Add image
    doc.addImage(imgData, 'PNG', 10, 10, 30, 30);

    // Add 'INVOICE' word next to image
    doc.setFontSize(18);
    doc.text("INVOICE", 150, 25);

    // Add breaker (divider) after image and INVOICE word
    doc.setDrawColor(200);
    doc.setLineWidth(0.5);
    doc.line(10, 40, 200, 40);

    // Add labels/text below breaker
    doc.setFontSize(10);
    doc.text(`Billed To:`, 10, 50);
    let y = 60;
    const lineSpacing = 7; // reduced spacing
    doc.text(`Email: ${email}`, 10, y);
    doc.text(`Invoice #: ${invoiceNumber}`, 150, y);
    y += lineSpacing;
    doc.text(`Name: ${name}`, 10, y);
    doc.text(`Invoice Date: ${invoiceDate}`, 150, y);
    y += lineSpacing;
    doc.text(`Phone: ${phone}`, 10, y);
    doc.text(`Status: ${status}`, 150, y);
    y += lineSpacing;
    doc.text(`Payment Method: ${paymentMethod}`, 150, y);

    // Add breaker (divider) after invoice details, before table
    const breakerY = 95; // add a small margin after payment method
    doc.setDrawColor(200);
    doc.setLineWidth(0.5);
    doc.line(10, breakerY, 200, breakerY);

    // Add table
    autoTable(doc, {
      startY: breakerY + 5,
      head: [['Service', 'Qty', 'Unit Cost', 'Discount', 'Price']],
      body: [
        ['60min', '1', '20$', '0$', '20$'],
        ['Court Name: ABC Court', '', 'Sub Total', '', '20$'],
        ['Address: 123 Street', '', 'VAT (10%)', '', '2$'],
        ['Contact: +123456789', '', 'Total', '', '22$'],
        ['Notes: Payment due within 7 days.', '', '', '', ''],
      ],
      didParseCell: function (data: CellHookData) {
        // Make all cells in Sub Total, VAT, and Total rows (except first column) grey
        if (
          (data.row.index === 1 && data.column.index > 0) || // Sub Total row
          (data.row.index === 2 && data.column.index > 0) || // VAT row
          (data.row.index === 3 && data.column.index > 0)    // Total row
        ) {
          data.cell.styles.fillColor = [224, 224, 224]; // grey
        }
      },
      headStyles: { fillColor: [33, 150, 243], textColor: 255 },
    });

    doc.save('invoice.pdf');
  };
};
